module.exports = __webpack_public_path__ + "img/banner_768.7ec30fc0.webp";